import Api from '../@base/Api';

export default class TransportModesApi extends Api {
    getAllTransportModes(language) {
        return super.get(`/transportmode?locale=${language}`);
    }

}